var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbandonCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#FE0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17H24.5L27.5 24.5L23.75 26.75C25.3564 30.0073 27.9927 32.6436 31.25 34.25L33.5 30.5L41 33.5V39.5C41 40.2956 40.6839 41.0587 40.1213 41.6213C39.5587 42.1839 38.7956 42.5 38 42.5C32.1489 42.1444 26.6302 39.6597 22.4852 35.5148C18.3403 31.3698 15.8556 25.8511 15.5 20C15.5 19.2044 15.8161 18.4413 16.3787 17.8787C16.9413 17.3161 17.7044 17 18.5 17ZM35 17L41 23L35 17ZM41 17L35 23L41 17Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17L40 23M40 17L34 23L40 17Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbandonCall);
export default __webpack_public_path__ + "static/media/AbandonCall.3523d8810800dd0d392a5e3e1c0d54eb.svg";
export { ForwardRef as ReactComponent };